<script>
import Modal from '@/components/Modal.vue'
import { getMiniAppAccessToken } from '@/apis/agora.api'
import { mapState } from 'vuex'
import jrQrcode from 'jr-qrcode'
import { getExamId } from '@/utils'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: false,
      qrcode: '',
      imageLoading: true
    }
  },
  computed: {
    ...mapState(['user'])
  },

  watch: {
    show(val) {
      if (val) {
        this.generateQRCode()
      }
    }
  },
  methods: {
    close() {
      this.show = false
    },
    open() {
      this.show = true
    },
    async generateQRCode() {
      this.imageLoading = true
      try {
        const { key } = await getMiniAppAccessToken('wxe4db96436318d03f',
          this.$route.query.examId || getExamId()
        )

        const miniUrl = `${window.location.protocol}//${window.location.host}/proctoring-mini?key=${key}`

        const qrcode = jrQrcode.getQrBase64(miniUrl)
        this.qrcode = qrcode
        this.imageLoading = false
      } catch (e) {
        this.$message.error('二维码生成失败')
        this.imageLoading = false
      }
    }
  }
}
</script>
<template>
  <Modal
    width="380px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
    class="detect-tip-modal"
  >
    <p slot="header">温馨提示</p>
    <div slot="content">
      <div class="tips">
        <div class="ExclamationCircle" />
        <p class="text">
          系统检测到您的手机摄像头处于异常状态！请使用微信扫描如下二维码选择摄像头。
        </p>
      </div>
      <p class="text red-text">手机摄像未连接，可能增加判断作弊的风险！</p>
      <div class="qrcode-box" v-if="!imageLoading">
        <img :src="qrcode" class="qr-code-img" />
        <span class="renew-icon" @click="generateQRCode"></span>
      </div>
      <div v-else class="qr-code-img">
        <span class="line-md--loading-alt-loop"></span>
      </div>
      <div class="refresh-btn-wrapper">
        <button @click="generateQRCode" class="refresh-button" :class="{ 'loading': imageLoading }">刷新二维码</button>
      </div>
    </div>
  </Modal>
</template>
<style lang="scss" scoped>
.ExclamationCircle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ffa940;
  position: relative;
  flex-shrink: 0;
  margin-right: 10px;
  margin-top: 2px;
}
.ExclamationCircle::after {
  content: '!';
  color: #ffa940;
  font-size: 13px;
  font-weight: bold;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tips {
  display: flex;
  margin-bottom: 4px;
}
.text {
  font-size: 14px;
  color: #000000d9;
  line-height: 22px;
  font-weight: 400;
}
.red-text {
  color: #f5222d;
  margin-left: 30px;
}
.qr-code-img {
  width: 144px;
  height: 144px;
  margin: auto;
  margin-top: 24px;
  position: relative;
  display: block;
}

.line-md--loading-alt-loop {
  display: inline-block;
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cg fill='%23000'%3E%3Ccircle cx='12' cy='3.5' r='1.5'%3E%3CanimateTransform attributeName='transform' calcMode='discrete' dur='2.4s' repeatCount='indefinite' type='rotate' values='0 12 12;90 12 12;180 12 12;270 12 12'/%3E%3Canimate attributeName='opacity' dur='0.6s' repeatCount='indefinite' values='1;1;0'/%3E%3C/circle%3E%3Ccircle cx='12' cy='3.5' r='1.5' transform='rotate(30 12 12)'%3E%3CanimateTransform attributeName='transform' begin='0.2s' calcMode='discrete' dur='2.4s' repeatCount='indefinite' type='rotate' values='30 12 12;120 12 12;210 12 12;300 12 12'/%3E%3Canimate attributeName='opacity' begin='0.2s' dur='0.6s' repeatCount='indefinite' values='1;1;0'/%3E%3C/circle%3E%3Ccircle cx='12' cy='3.5' r='1.5' transform='rotate(60 12 12)'%3E%3CanimateTransform attributeName='transform' begin='0.4s' calcMode='discrete' dur='2.4s' repeatCount='indefinite' type='rotate' values='60 12 12;150 12 12;240 12 12;330 12 12'/%3E%3Canimate attributeName='opacity' begin='0.4s' dur='0.6s' repeatCount='indefinite' values='1;1;0'/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E");
  background-color: currentColor;
  -webkit-mask-image: var(--svg);
  mask-image: var(--svg);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.qrcode-box {
  position: relative;
  margin: auto;
  margin-top: 24px;
  width: 144px;
  height: 144px;
  .renew-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    overflow: hidden;
  }
  .renew-icon::after {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    --svg: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M12.077 19q-2.931 0-4.966-2.033q-2.034-2.034-2.034-4.964t2.034-4.966T12.077 5q1.783 0 3.339.847q1.555.847 2.507 2.365V5.5q0-.213.144-.356T18.424 5t.356.144t.143.356v3.923q0 .343-.232.576t-.576.232h-3.923q-.212 0-.356-.144t-.144-.357t.144-.356t.356-.143h3.2q-.78-1.496-2.197-2.364Q13.78 6 12.077 6q-2.5 0-4.25 1.75T6.077 12t1.75 4.25t4.25 1.75q1.787 0 3.271-.968q1.485-.969 2.202-2.573q.085-.196.274-.275q.19-.08.388-.013q.211.067.28.275t-.015.404q-.833 1.885-2.56 3.017T12.077 19'/%3E%3C/svg%3E");
    background-color: currentColor;
    -webkit-mask-image: var(--svg);
    mask-image: var(--svg);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
  }
}

.refresh-btn-wrapper {
  text-align: center;
}

.refresh-button {
  padding: 6px 16px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #409EFF;
  background: #409EFF;
  color: #fff;
  cursor: pointer;
  margin-top: 8px;
  &.loading {
    pointer-events: none;
    background-color: rgba(0, 0, 0, 0.5);
    border-color: rgba(0, 0, 0, 0);
  }
}
</style>
